import { writable } from 'svelte/store';

export const fileUploadStore = writable(<Array<File>>[]);
